// components/Account.tsx
import React, { useEffect, useState } from 'react';
import { post } from '../httpService';

const Account: React.FC = () => {
    const [userData, setUserData] = useState<any>(null);
    const [apiKey, setApiKey] = useState<any>(null);

    useEffect(() => {
        const saved = localStorage.getItem("authUser");
        if (saved) {
            setUserData(JSON.parse(saved));
        }

        getApiKey();

    }, []);

    const getApiKey = () => {
        // Effectuez une requête GET pour les clés API
        post('/api-keys', null)
            .then((response) => {
                setApiKey(response.data);
            })
            .catch((error) => {
                console.error('Erreur GET clés API :', error);
            });
    }

    if (!userData) {
        return <div>Loading...</div>;
    }

    return (
        <div className="container mx-auto p-6">
            <div className="bg-white  rounded-lg p-6">
                <div className="flex items-center space-x-6">
                    <img src={userData.image} alt="Profile" className="w-24 h-24 rounded-full object-cover bg-gray" />
                    <div>
                        <h2 className="text-xl font-semibold">{userData.first_name} {userData.last_name}</h2>
                        <p className="text-gray-600">@{userData.user_name}</p>
                        <p className="text-gray-600">{userData.email}</p>
                    </div>
                </div>
            </div>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div className="bg-white rounded-lg p-6">
                    <h3 className="text-lg font-semibold mb-4">Informations Personnelles</h3>
                    <p><strong>ID:</strong> {userData.id}</p>
                    <p><strong>Date de naissance:</strong> {userData.date_of_birth}</p>
                    <p><strong>Téléphone:</strong> {userData.code} {userData.phone}</p>
                    <p><strong>Type de compte:</strong> {userData.account_type}</p>
                </div>

                <div className="bg-white rounded-lg p-6">
                    <h3 className="text-lg font-semibold mb-4">Clés API</h3>
                    <p><strong>Clé API : </strong> </p>
                    <p><strong>Has code : </strong> </p>
                </div>

                <div className="bg-white rounded-lg p-6">
                    <h3 className="text-lg font-semibold mb-4 text-center">QR Code Seremo</h3>
                    <img src={`https://api.qrserver.com/v1/create-qr-code/?data=${userData.qr_code}&size=200x200`} alt="QR Code" className="mx-auto" />
                </div>
            </div>

            <div className="mt-6 bg-white  rounded-lg p-6">
                <h3 className="text-lg font-semibold mb-4">Activité du Compte</h3>
                <p><strong>Créé le:</strong> {new Date(userData.created_at).toLocaleString()}</p>
                <p><strong>Mis à jour le:</strong> {new Date(userData.updated_at).toLocaleString()}</p>
            </div>
        </div>
    );
}

export default Account;
